<template>
  <div class="mainContainer">
    <ClientElseStatementsVue />
  </div>
</template>

<script>
import ClientElseStatementsVue from '@/views/settle/client/clientElseStatements/index.vue';

export default {
  components: { ClientElseStatementsVue },
  data() {
    return {
      
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped></style>
